//this is used for page slide in transitions for settings, dashboard and starhub pages.

import React from 'react';
import { motion } from 'framer-motion';

// ✅ Use percentages instead of viewport units for animations within a container
const pageVariants = {
  right: {
    initial: { x: '100%' },
    animate: { x: '0%' },
    exit: { x: '100%' },
  },
  // You can add a 'top' variant here later if you refactor StarHubPage
};

const pageTransition = {
  type: 'spring',
  stiffness: 260,
  damping: 30,
};

const AnimatedPageWrapper = ({ children, direction = 'right' }) => {
  return (
    <motion.div
      variants={pageVariants[direction]}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
      // ✅ FIX: This now positions the page absolutely within its parent, not the whole screen
      className="absolute top-0 left-0 w-full h-full"
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPageWrapper;